import getIconName from "./getIconName";
import { unitTypes } from "./index";

const getArea = (metaObject: any) => {
  let area = null;
  const area_unit = metaObject.area_unit || "sqft";
  if (metaObject.area) {
    area = `${metaObject.area} ${area_unit}`;
  } else if (metaObject.min_area) {
    if (metaObject.max_area) {
      area = `${metaObject.min_area} - ${metaObject.max_area} ${area_unit}`;
    } else {
      area = `${metaObject.min_area} + ${area_unit}`;
    }
  } else if (metaObject.max_area) {
    area = `${metaObject.max_area} ${area_unit}`;
  }
  return area;
};

const getFormattedTags = (data: any, t: any): any => {
  const tags = [];
  const types = data?.meta?.types_en || data?.meta?.types || [];
  const floor = data?.meta?.floor || 0;
  const unitType = data?.meta?.unit_type;
  const area = data?.meta ? getArea(data.meta) : null;

  if (unitType) {
    // @ts-ignore
    tags.push({ icon: getIconName(unitTypes[unitType]), text: unitTypes[unitType] });
  }

  if (types.length) {
    const privateRoom = types.indexOf("private_room") > -1;
    const privateBathroom = types.indexOf("private_bathroom") > -1;
    let sharedBathroom = false;
    if (!privateBathroom) {
      sharedBathroom = types.indexOf("shared_bathroom") > -1;
    }
    const entirePlace = types.indexOf("entire_place") > -1;
    const sharedRoom = types.indexOf("shared_room") > -1;
    const apartment = types.indexOf("apartment") > -1;
    const privateKitchen = types.indexOf("private_kitchen") > -1;
    let sharedKitchen = false;
    if (!privateKitchen) {
      sharedKitchen = types.indexOf("shared_kitchen") > -1;
    }

    if (privateRoom && !entirePlace) {
      tags.push({ icon: getIconName("room"), text: t("mischlaneous.private_room") });
    }
    if (entirePlace) {
      tags.push({ icon: getIconName("home"), text: t("Entire Place") });
    }
    if (sharedRoom) {
      tags.push({ icon: getIconName("beds"), text: t("Shared Room") });
    }
    if (apartment) {
      tags.push({ icon: getIconName("beds"), text: t("Apartment") });
    }
    if (privateBathroom) {
      tags.push({ icon: getIconName("bathroom"), text: t("Private Bathroom") });
    }
    if (sharedBathroom) {
      tags.push({ icon: getIconName("bathroom"), text: t("Shared Bathroom") });
    }
    if (sharedKitchen) {
      tags.push({ icon: getIconName("kitchen"), text: t("Shared Kitchen") });
    }
    if (privateKitchen) {
      tags.push({ icon: getIconName("kitchen"), text: t("Private Kitchen") });
    }
  }

  if (floor) {
    tags.push({
      icon: getIconName("floor"),
      text: `${t ? t("Floor") : "Floor"} ${floor}`,
      key: t("Floor"),
    });
  }

  if (area) {
    tags.push({ icon: getIconName("area"), text: `${t(area)}`, value: area });
  }

  return tags;
};

export default getFormattedTags;
export { getArea };
